import { render, staticRenderFns } from "./RcTermsStep.vue?vue&type=template&id=97f82cce&scoped=true"
import script from "./RcTermsStep.vue?vue&type=script&lang=js"
export * from "./RcTermsStep.vue?vue&type=script&lang=js"
import style0 from "./RcTermsStep.vue?vue&type=style&index=0&id=97f82cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f82cce",
  null
  
)

export default component.exports